<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDocumenti > 0"
      item-key="_id"
      :headers="headers"
      :items="documenti"
      :options.sync="options"
      :server-items-length="totaleDocumenti"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="false"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>
          Seleziona le anteprime da convertire in fattura definitiva
          <v-btn icon @click="onRefresh" title="Aggiorna"><v-icon>mdi-refresh</v-icon></v-btn>
          <v-btn class = "ml-5" small color="success" @click.stop="onAggiungiTutti">Aggiungi tutte</v-btn>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="success" class="mb-2 mr-5" @click="onCreaDefinitive" :loading="generazioneInCorso" :disabled="generazioneInCorso">Crea fatture definitive</v-btn>
<!--         <v-btn color="primary" dark class="mb-2" @click="onNuovoDocumento">Nuovo Documento</v-btn> -->
        <!-- <dialog-errore :show="dialogErrore" :title="errorTitle" :message="errorMessage" @dialogConfirm="dialogErrore = false"/> -->
        <dialog-stampa
          :show="dialogStampa"
          title="Stampa Etichette"
          confirmText="Stampa"
          cancelText="Annulla"
          :totaleEtichette="totaleEtichette"
          :isStampaEtichette="true"
          :isModuloA4="isModuloA4"
          @dialog-print="onDialogPrint"
          @dialog-cancel="onDialogCancel"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | date }}
    </template>
    <template v-slot:[`item.totali.generale.imponibile`]="{ item }">
      {{ item.totali.generale.imponibile | euro }}
    </template>
    <template v-slot:[`item.totali.generale.iva`]="{ item }">
      {{ item.totali.generale.iva | euro }}
    </template>
    <template v-slot:[`item.totali.generale.importo`]="{ item }">
      {{ item.totali.generale.importo | euro }}
    </template>        
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small @click="dettaglioItem(item)" class="mr-2" title="Dettaglio del documento">mdi-archive-eye-outline</v-icon>
      <v-icon small @click="stampaProforma(item)" class="mr-2" title="Stampa fattura proforma">mdi-printer-outline</v-icon>
      <v-icon small @click="deleteItem(item)" title="Cancella la fattura proforma">mdi-delete</v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template>
    </v-data-table>
    <!-- <speed-dial @comando="onSpeedDialogComando"/> -->
    <!-- <dettaglio-fattura :showDialog="showDettaglioFattura" :idDocumento="idDocumento" :trigger="triggerUpdate"/> -->
    <edit-documento :showDialog="showDettaglioFattura" :idDocumento="idDocumento" :readOnly="true" :trigger="triggerUpdate" />
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione fattura proforma?</v-card-title>
        <v-card-text>I DDT contenuti verranno riabilitati per la modifica e la successiva fatturazione</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { dynamicSortMultiple, downloadXml, getAnnoRiferimento } from '@/components/helpers.js'
  import DialogStampa from '@/components/dialogStampa'
  /* import DettaglioFattura from '../fatture/dettaglioFattura' */
  import EditDocumento from '../edit/editDocumento'
  /* import SpeedDial from '../speedDial.vue' */
  import configurazioni from '@/services/configurazioniService.js'
  import moment from 'moment'
  import documenti from '@/services/documentiService.js'
  import scontrini from '@/services/scontriniService.js'
  import xml7 from '@/services/xml7Service.js'
  import etichetteService from '@/services/etichetteService.js'
  import reporting from '@/services/reportingService.js'
  import elettronica from '@/services/elettronicaService.js'
  const labelsPath = window.appConfig.VUE_APP_MOL_S_LABELS

  export default {
    components: {
      /* SpeedDial, */
      DialogStampa,
      /* DettaglioFattura, */
      EditDocumento
    },
    props: {
      ddt: Array
    },
    data () {
      return {
        totaleDocumenti: 0,
        documenti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Numero anteprima', value: '_id'},
          { text: 'Data', value: 'data' },
          { text: 'Codice cliente', value: 'anagrafica.cliente.codice' },
          { text: 'Ragione sociale', value: 'anagrafica.cliente.ragioneSociale' },
          { text: 'Imponibile', value: 'totali.generale.imponibile' },
          { text: 'Iva', value: 'totali.generale.iva' },
          { text: 'Importo', value: 'totali.generale.importo' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false,
        // salta: 0,
        tipoStampa: '',
        report: '',
        isModuloA4: false,
        errorTitle: 'Errore aggiornamento Documento',
        errorMessage: '',
        // showDialogMultiple: false,
        showDettaglioFattura: false,
        idDocumento: '',
        triggerUpdate: 1,
        generazioneInCorso: false,
        infoEmail: null,
        infoFatturazione: null
      }
    },
    async created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
      await this.getDefaultItem()
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      const email = _.get(impostazioni, 'email')
      this.infoEmail = email
      const info = _.get(impostazioni, 'fatturazione')
      this.infoFatturazione = info      
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Documento' : 'Modifica Documento'
      },
      documentiSaved() {
        return this.$store.getters['documenti/saved']
      },
      testataAperta() {
        return this.$store.getters['documenti/page'] === 'testata'
      },
      refreshList() {
        // console.log('refreshList')
        return this.$store.getters['documenti/refreshProforma']
      },
      documentiSorted() {
        const els = this.documenti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.sum(elSel.map(x => x.qtaAnagrafica))
          const totaleDocumenti = _.sum(elSel.map(x => x.qtaDocumenti))
          return { totaleAnagrafica, totaleDocumenti }
        } else {
          return { totaleAnagrafica: 0, totaleDocumenti: 0 }
        }
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async documentiSaved(value) {
        if (value && this.testataAperta) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'proforma')
        }
      }
    },
    /*     async created() {
      await this.getDefaultItem()
    }, */
    async mounted () {
      await this.getDataFromApi()
    },
    methods: {
      async onRefresh() {
        await this.getDataFromApi()
      },
      onAggiungiTutti() {
        this.selected = [...this.documenti]
      }, 
      async getDefaultItem() {
        this.defaultItem = await documenti.getModello('xxx')
        this.defaultItem.data = new Date()
      },
      async onRicerca(filtri) {s
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          this.filtri = {
            tipoDocumento: ['fatturaProforma'],
            fatturata: false
            // altro filtro per evidenziare che non è stata generata fattura XML ... verificare
          }

          const data = await documenti.getFilteredDocumentHeaders(this.filtri, this.options)
          this.documentiRaw = data && data.total_rows > 0 ? data.rows : []
          this.documenti = this.documentiRaw
          this.totaleDocumenti = data.total_rows
        } catch(err) {
          this.documenti = []
          this.totaleDocumenti = 0
        } finally {
          this.loading = false
        }
      },
      async generaXmlItem(item) {
        // Generazione XML Demo. La fattura definitiva non viene ancora creata
        const documento = await documenti.getDocumento(item._id)
        if (documento) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(documento)
          downloadXml(document, nomeFile, xml7File)
        }
      },

      async stampaProforma(item) {
        try {
          const result = await reporting.stampaDocumento(this.$router, item, true, true)
          if (result && result.error) {
            console.log(result.error)
          }
        } catch {}
      },
      abilitaInvioSDI(item) {
        if (!this.infoFatturazione) return false
        if (this.infoFatturazione.tipiDocumento.includes(item.tipoDocumento.tipoDocumento)) {
          return this.infoFatturazione ? this.infoFatturazione.invioAutomaticoSDI : false
        } else {
          return false
        }
      },
      xmlTrasferito(item) {
        return _.get(item, 'tipoDocumento.xml.fileTrasferito', false)
      },
      async onCreaDefinitive(item) {
        this.generazioneInCorso = true
        const elSel = this.selected

        if (elSel.length > 0) {
          const idsDocumenti = elSel.map(x => x._id)
          const result = await documenti.creaFattureDefinitive(idsDocumenti)
          const items = await documenti.getDocumentiByIds(result)
          for (let item of items) {
            if (this.abilitaInvioSDI(item)) {
              if (this.xmlTrasferito(item)) return
              const xmlResult = await xml7.creaXml7Multipli([item._id])
              if (xmlResult.length > 0) {
                const ft = xmlResult[0]
                const result = await elettronica.trasferisciXml(item._id, ft.file, ft.link)
              }
            }
          }
        }
        this.annullaSelezione()
        this.$store.commit('documenti/SET_REFRESH', 'definitive')
        await this.getDataFromApi()
        this.$emit('creazione-differite-completa')

        this.generazioneInCorso = false
      },

      async onNuovoDocumento() {
        this.editedIndex = -1
        await this.getDefaultItem()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.$store.commit('documenti/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      async dettaglioItem (item) {
        this.idDocumento = item._id
        this.showDettaglioFattura = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDettaglioFattura = false
/*         this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('documenti/SET_CHIAVE', this.editedItem)
        this.$emit('apriDettaglio', this.editedItem) */
      },
/*       async editItem (item) {
        this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = await documenti.getDocumento(item._id)
        await this.completaAppoggio()
        this.$store.commit('documenti/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      }, */
/*       async completaAppoggio() {
        let itm = this.editedItem
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        // const clienteId =  _.get(itm.anagrafica, 'cliente.codice', '') || _.get(itm.anagrafica, 'fornitore.codice', '')
        // const clifor = await clienti.getCliente(clienteId)
        const clifor = _.get(itm.anagrafica, 'cliente', '') || _.get(itm.anagrafica, 'fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },   */    
      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedIndex = -1
        })        
      },
      deleteItem (item) {
        this.editedIndex = this.documenti.indexOf(item)
        this.dialogDelete = true
      },      
      async deleteItemConfirm () {
        const documento = this.documenti[this.editedIndex]
        try {
          const idsScontrini = await scontrini.scontriniDaProforma(documento._id)
          if(idsScontrini.length){
            for (let idScontrino of idsScontrini) {
              const scontrino = await scontrini.getScontrinoById(idScontrino)
              delete scontrino.documento.tipoDocumento.fatturaRiepilogativa
              await scontrini.updateScontrinoNoMerge(idScontrino, scontrino)
            }
          }
          const idsDdt = await documenti.ddtDaProforma(documento._id)
          if(idsDdt.length){
            for (let idDdt of idsDdt) {
              const ddt = await documenti.getDocumento(idDdt)
              delete ddt.tipoDocumento.fatturaRiepilogativa
              await documenti.aggiornaDocumento(ddt)
            }
          }
          // const ids = this.ddt.map(x => x._id)
          // const updatedDdt = await documenti.getDocumentiByIds(ids)
          // const ddtFattura =  updatedDdt.filter(x => _.get(x, 'tipoDocumento.fatturaRiepilogativa', '') === documento._id)
          // const idsDdt = ddtFattura.map(x => x._id)
          // // cicla su tutte le ddt che hanno il documento come proforma ...  
          // for (let d of idsDdt) {
          //   const ddt = await documenti.getDocumento(d)
          //   delete ddt.tipoDocumento.fatturaRiepilogativa
          //   await documenti.aggiornaDocumento(ddt)
          // }
          await documenti.cancellaDocumento(documento._id)
        } catch {}

        this.documenti.splice(this.editedIndex, 1)
        this.dialogDelete = false
      },      
      async save () {
        this.$store.commit('documenti/CLEAR_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['documenti/documento']
        if (this.editedIndex > -1) {
          // verificare
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteModifica = this.$store.getters.utente
          Object.assign(this.documenti[this.editedIndex], this.editedItem)
          if (!await documenti.aggiornaDocumento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          const numeratore = this.editedItem.tipoDocumento.numeratore
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteCreazione = this.$store.getters.utente
          // sarebbe meglio mettere il numeratore su documenti, ma finchè non c'è molecular fa troppi giri ....
          const annoRiferimento = getAnnoRiferimento(this.editedItem.data) // this.editedItem.data.getFullYear()
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          this.editedItem.codice = numero
          this.editedItem._id = numero
          this.documenti.push(this.editedItem)
          if (!await documenti.creaDocumento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.editedItem = null
        this.editedIndex = -1
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi()
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      async dblclickRow(event, options) {
        const item = options.item
        await this.dettaglioItem(item)
        // this.editItem (item)
/*         this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('documenti/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        })
        return elaborati
      },
      deleteDatiVisualizzazione(documento) {
        let locDocumento = {...documento}
        delete locDocumento.c_nominativo
        delete locDocumento.appoggio
        return locDocumento
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
/*             this.tipoStampa = impostazioni.tipo
            this.report = impostazioni.report
            this.isModuloA4 = impostazioni.tipo === 'pdf' */
            this.dialogStampa = true
            break
          default:
            break
        }
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        // this.salta = salta
        this.dialogStampa = false
        const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'documento'
        const documenti = this.selected
        for (let mm of documenti) {
          const filtriAggiuntivi = [{
            applicazione: 'documenti',
            chiave: 'riferimento.id',
            testo: mm.riferimento.id
          }]
          const parametri = {
            articoli: true,
            filtri: filtriAggiuntivi,
            gruppi: [],
            tipoQuantita
          }
          const filtro = {
            start: moment(mm.data).startOf('day').format('YYYYMMDD'),
            end: moment(mm.data).endOf('day').format('YYYYMMDD')
          }
          const filtroElementi = { filtro, parametri }
          const src = `${labelsPath}/${tipoStampa}/${report}?elm=${btoa(JSON.stringify(filtroElementi))}${salta ? '&sk=' + salta : ''}${tipoQuantita ? '&tpq=' + tipoQuantita : ''}`
          const printResult = await etichetteService.stampaDiretta(tipoStampa, src)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }
        }
        this.annullaSelezione()
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

</style>
